var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpgFileTypeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101010;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xxx-word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,330H125a5,5,0,0,1,0-10h75a5,5,0,1,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.86,182.68v36.8q0,9.18-4,13.26t-12.64,4.08a28.7,28.7,0,0,1-7.77-.82v-7.73q4.37.31,6.17.31,4.8,0,6.56-1.8t1.76-7.3v-36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.68,236h-9.61V182.68h21.84q9.34,0,13.85,4.71a16.37,16.37,0,0,1-.37,22.95A17.49,17.49,0,0,1,194,214.87H180.68Zm0-29.37h11.37q4.45,0,6.8-2.19a7.58,7.58,0,0,0,2.34-5.82A8,8,0,0,0,199,193q-2.17-2.34-7.83-2.34H180.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.47,208.73V236h-4.26l-2.93-7.19q-4.65,8-14.41,8-10.9,0-16.27-8.28a34.45,34.45,0,0,1-5.37-19.18q0-11.52,6-19.51t16.78-8q8,0,13.24,4.67a20.55,20.55,0,0,1,6.56,11.62l-8.36,1.48q-2.34-9.76-11.21-9.77a11.17,11.17,0,0,0-9.24,4.61q-3.57,4.61-3.57,14.18,0,20.2,12.66,20.2a10.74,10.74,0,0,0,8.14-3.4,12.52,12.52,0,0,0,3.22-9h-11v-7.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgFileTypeSvgrepoCom);
export default __webpack_public_path__ + "static/media/jpg-file-type-svgrepo-com.2e260f4fdf9efa8564cc65687835c9b2.svg";
export { ForwardRef as ReactComponent };